import React from "react";
import { Link as RouterLink } from "react-router-dom";

import Button from "@material-ui/core/Button";
import ReplayIcon from "@material-ui/icons/Replay";

import { useStyles } from "./inputs-button-styles";

export default () => {
  const classes = useStyles();

  return (
    <Button
      className={classes.root}
      component={RouterLink}
      variant="contained"
      color="primary"
      size="large"
      startIcon={<ReplayIcon />}
      to="/"
    >
      Пересчитать
    </Button>
  );
};
